import { ViewIds } from '@ardoq/api-types';

/**
 * Settings whose changes are not worth an analytics event.
 *
 * `layoutData` is the Blocks view's saved node positions - a blob that changes on every drag and
 * says nothing a reader of the event could use.
 */
export const IGNORED_SETTINGS_BY_VIEW_ID = new Map<ViewIds, string[]>([
  [ViewIds.BLOCKS, ['layoutData']],
]);
